module.exports = __webpack_public_path__ + "img/es.1c040c2c.png";